import React from "react";
import SubscriptionCard from "./SubscriptionCard";
import { Box } from "@mui/material";
// let data = [
//   {
//     _id: "661d69a29728795c7e0e3803",
//     name: "STARTER",
//     price: 2.99,

//     about:
//       "Ad non consectetur duis sunt occaecat. Amet do sunt esse et eiusmod\r\n",
//     features: ["2 courses", "2 Market Products for Sale"],
//   },
//   {
//     _id: "661d69a23c76de0a40aea4a3",
//     name: "BUSINESS",
//     price: 3.99,
//     about:
//       "Ad non consectetur duis sunt occaecat. Amet do sunt esse et eiusmod\r\n",
//     features: ["5 courses", "5 Market Products for Sale"],
//   },
//   {
//     _id: "661d69a2f5f96d2b50e7d10a",
//     name: "SCALE-UP",
//     price: 4.99,
//     about:
//       "Ad non consectetur duis sunt occaecat. Amet do sunt esse et eiusmod\r\n",
//     features: ["8 courses", "8 Market Products for Sale"],
//   },
// ];
const Monthly = ({ data }) => {
  const monthlyData = Array.isArray(data)
    ? data.filter((item) =>
        item.plans?.some((plan) => plan.title === "Monthly")
      )
    : [];

  const modifiedData = monthlyData.map((item) => ({
    ...item,
    plans: item.plans.map((plan) => ({
      ...plan,
      about: item.name === "Free"
      ? ` This is the free plan, which offers limited features.`
        :item.name === "basic"
          ? ` This is the basic plan, which offers limited features.`
          : item.name === "premium "
          ? ` This is the premium plan, which offers exclusive features.`
          : plan.about,
    })),
  }));

  return (
    <Box
      sx={{
        display: "flex",
        gap: "40px",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {modifiedData &&
        modifiedData.map((item) => {
          return <SubscriptionCard key={item._id} data={item} plan={"mo"} />;
        })}
    </Box>
  );
};

export default Monthly;
